export const SPECIAL_SEASON = {
	id: "-",
	label: "Out of season",
}
